import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

/**
 * Tracks the open section-settings drawer in the `section` search param so a
 * settings drawer survives refresh and is shareable.
 */
const useOpenSectionSettings = <T extends { id: string }>(sections?: T[]) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const sectionId = searchParams.get('section');

  const setSectionId = useCallback(
    (next: string | null) => {
      setSearchParams(
        (prev) => {
          if (next) {
            prev.set('section', next);
          } else {
            prev.delete('section');
          }
          return prev;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  const matchedSection = sections?.find((s) => s.id === sectionId) ?? null;

  return {
    sectionId,
    matchedSection,
    setSectionId,
  } as const;
};

export default useOpenSectionSettings;
